import { c as _c } from "react/compiler-runtime";
import { cn } from '@achra/ui/lib/utils';
import React from 'react';
interface ExpenseArrowProps extends React.SVGProps<SVGSVGElement> {
  isIncoming?: boolean;
  isSwap?: boolean;
}
function ExpenseArrow(t0) {
  const $ = _c(19);
  let className;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      isIncoming: t1,
      isSwap: t2,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    className = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const isIncoming = t1 === undefined ? false : t1;
  const isSwap = t2 === undefined ? false : t2;
  if (isSwap) {
    let t3;
    if ($[5] !== className) {
      t3 = cn("text-status-progress size-4 opacity-30", className);
      $[5] = className;
      $[6] = t3;
    } else {
      t3 = $[6];
    }
    let t4;
    if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <path d="M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM9.65137 11.7607C9.07671 11.2221 8.14494 11.2221 7.57031 11.7607L4.43066 14.7031C3.85658 15.2417 3.8565 16.1148 4.43066 16.6533L7.57031 19.5957C8.14498 20.1342 9.07678 20.1343 9.65137 19.5957C10.2256 19.0571 10.2257 18.1841 9.65137 17.6455L9.02344 17.0576H18.0283C18.8408 17.0574 19.5 16.4394 19.5 15.6777C19.4997 14.9163 18.8406 14.299 18.0283 14.2988H9.02441L9.65137 13.7109C10.2257 13.1724 10.2256 12.2994 9.65137 11.7607ZM15.9297 4.4043C15.355 3.86563 14.4233 3.86563 13.8486 4.4043C13.2741 4.94297 13.274 5.81587 13.8486 6.35449L14.4766 6.94238H5.47168C4.659 6.94238 4 7.56048 4 8.32227C4.00026 9.08385 4.65916 9.70117 5.47168 9.70117H14.4756L13.8486 10.2891C13.2742 10.8277 13.2742 11.7006 13.8486 12.2393C14.4233 12.7779 15.355 12.7779 15.9297 12.2393L19.0693 9.29785C19.6438 8.75934 19.6435 7.88538 19.0693 7.34668L15.9297 4.4043Z" fill="currentColor" />;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== props || $[9] !== t3) {
      t5 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={t3} {...props}>{t4}</svg>;
      $[8] = props;
      $[9] = t3;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  const t3 = isIncoming ? "text-status-success" : "text-destructive";
  const t4 = !isIncoming;
  let t5;
  if ($[11] !== className || $[12] !== t3 || $[13] !== t4) {
    t5 = cn("size-4 opacity-30", t3, className, {
      "rotate-180": t4
    });
    $[11] = className;
    $[12] = t3;
    $[13] = t4;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  let t6;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <path fillRule="evenodd" clipRule="evenodd" d="M8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0ZM8.01246 12.915C7.45185 12.9268 6.77225 12.1915 6.77225 12.1915L4.2011 9.1273C3.8461 8.70422 3.90128 8.03099 4.32436 7.67599C4.74743 7.32098 5.37819 7.37617 5.73319 7.79924L6.91504 9.20772L6.91504 4C6.91504 3.44771 7.44772 2.91504 8 2.91504C8.55228 2.91504 9.12337 3.44771 9.12337 4L9.12337 9.20772L10.2339 7.8842C10.5889 7.46113 11.2197 7.40594 11.6428 7.76095C12.0658 8.11595 12.121 8.70422 11.766 9.1273L9.19487 12.1915C9.19487 12.1915 8.5537 12.9037 8.01246 12.915Z" fill="currentColor" />;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== props || $[17] !== t5) {
    t7 = <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" className={t5} {...props}>{t6}</svg>;
    $[16] = props;
    $[17] = t5;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  return t7;
}
export { ExpenseArrow };